<section class="w-full h-250">
    <div class="flex flex-col items-center justify-center">
        <div class="w-[100%]">
            <div class="relative bg-primary-600">
                <div class="absolute inset-x-0 bottom-0">
                    <svg viewBox="0 0 215 12" fill="currentColor" class="w-full -mb-1 text-white"
                        preserveAspectRatio="none">
                        <path
                            d="M0,0 C48.8902582,6.27314026 86.2235915,9.40971039 112,9.40971039 C137.776408,9.40971039 175.109742,6.27314026 224,0 L224,12.0441132 L0,12.0441132 L0,0 Z">
                        </path>
                    </svg>
                </div>
                <div class="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
                    <div class="relative max-w-2xl sm:mx-auto sm:max-w-xl md:max-w-2xl sm:text-center">
                        <h2
                            class="mb-6 font-sans text-3xl text-center font-bold tracking-wide text-white sm:text-4xl sm:leading-none">
                            Subscribe & Travel for Less!
                        </h2>
                        <p class="mb-6 text-base text-white md:text-lg">
                            Get exclusive access to unbeatable travel deals, last-minute getaways, and special offers 
                            straight to your inbox. Be the first to know about our discounted vacation packages, cruise specials, 
                            and dream destinations!
                        </p>
                        <form class="flex flex-col items-center justify-center w-full mb-4 md:flex-row md:px-16">
                            @if (view.message) {
                                <h2 class="mb-6 font-sans text-3xl text-center justify-center font-bold tracking-wide sm:text-4xl sm:leading-none animate-pulse text-accent-500">
                                    {{view.message}}
                                </h2>
                            }
                            @if (!view.message) {
                            <input name="emailAddress" [(ngModel)]="view.emailAddress" placeholder="Email" required type="email"
                                [ngClass]="{'bg-white text-black': true, 'ring-2 ring-accent-500': view.emailAddress}"
                                class="flex-grow w-full bg-white h-12 px-4 mb-3 placeholder-gray-600 transition duration-200 rounded md:mr-2 md:mb-0" />
                            
                            
                            <button (click)="addSub()"
                                class="inline-flex items-center justify-center w-full h-12 px-6 font-semibold tracking-wide text-gray-200 transition duration-200 rounded bg-accent shadow-lg md:w-auto hover:bg-primary-900">Subscribe</button>
                            }
                        </form>
                        <p class="max-w-md text-xs tracking-wide text-white sm:text-sm sm:mx-auto">
                            Join thousands of travelers who save on their next adventure.<br/>No spam, just amazing travel deals!
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>